import React from 'react';
import '../Input/Input.css'; // Re-use Input styles for consistency

export default function Select({ 
  label, 
  error, 
  options = [], 
  placeholder,
  className = '', 
  value,
  ...props 
}) {
  // If options are strings, convert to objects
  const normalizedOptions = options.map(opt => 
    typeof opt === 'string' ? { value: opt, label: opt } : opt
  );

  return (
    <div className={`ui-form-group ${className}`}>
      {label && <label className="ui-label">{label}</label>}
      
      <div className={`ui-input-wrapper ${error ? 'has-error' : ''}`}>
        <select 
          className="ui-input ui-select"
          value={value}
          {...props}
        >
          {placeholder && <option value="" disabled>{placeholder}</option>}
          
          {normalizedOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      
      {error && <span className="ui-error-msg">{error}</span>}
    </div>
  );
}
